module.exports = __webpack_public_path__ + "img/recebíveis.1acbfeae.svg";